const ROUTES = {
	HOME: "/home",
	CART: "/cart",
	//USER
	LOGINUSER: "/",
	ACTIVATEUSER: "/user-activate",
	TRACK: "/track",
	MASONRY: "/masonry-items",
	ELECTRICAL: "/electrical-items",
	STEEL: "/steel-items",
	ROOFING: "/roofing-items",
	CONCRETING: "/concreting-items",
	FRAMING: "/framing-items",
	FLOORING: "/flooring-items",
	RECOMMENDATION: "/recommendation",
	CONTACT: "/contact",
	ALLCATEGORIES: "/all-categories",
	SEARCH: "/search",
	INTERIOR: "/interior",
	//VENDOR
	LOGINVENDOR: "/supplier-login",
	ACTIVATEVENDOR: "/supplier-activate",
	SUPPLIERHOME: "/supplier-dashboard",
	ADDPRODUCT: "/supplier/add-product",
	ORDERS: "/supplier/orders",
	PAYMENTANDTRANSACTION: "/supplier/payments-and-transactions",
	SUPPLIERCONTACT: "/supplier/contact",
	//ADMIN
	LOGINADMIN: "/admin-login",
	ADMINHOME: "/admin-dashboard",
	ADDUSERACCOUNT: "/admin/add-user-account",
	ADDVENDORACCOUNT: "/admin/add-supplier-account",
	ADDADMINACCOUNT: "/admin/add-admin-account",
	ACTIVATEADMIN: "/admin-activate",
};

export default ROUTES;
